module.exports = __webpack_public_path__ + "fonts/avenir/ca038835-1be3-4dc5-ba25-be1df6121499.svg";


//////////////////
// WEBPACK FOOTER
// ./fonts/avenir/ca038835-1be3-4dc5-ba25-be1df6121499.svg
// module id = 22
// module chunks = 0